import React, { useEffect, useState } from "react";
import OfferServices from "../services/externalServices/OfferServices";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  CardMedia,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import OfferDialog from "./OfferDialog";

function Offers() {
  const [offers, setOffers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentOffer, setCurrentOffer] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [offerToDelete, setOfferToDelete] = useState(null);

  useEffect(() => {
    getOffers();
  }, []);

  const getOffers = async () => {
    try {
      const res = await OfferServices.getAllOffers();
      setOffers(res); // Assuming res is the array of offers
    } catch (error) {
      console.log("Error getting the offers", error);
    }
  };

  const handleOpenDialog = (offer = null) => {
    setCurrentOffer(offer || {});
    setIsEditMode(!!offer);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentOffer(null);
  };

  const handleSaveOffer = async () => {
    try {
      if (isEditMode) {
        await OfferServices.updateOffer(currentOffer._id, currentOffer); // Assuming updateOffer API exists
      } else {
        await OfferServices.createOffers(currentOffer); // Assuming createOffer API exists
      }
      getOffers(); // Refresh offers list
      handleCloseDialog();
    } catch (error) {
      console.log("Error saving the offer", error);
    }
  };

  const handleDeleteOffer = async () => {
    try {
      if (offerToDelete) {
        await OfferServices.deleteOffer(offerToDelete._id); // Assuming deleteOffer API exists
        getOffers(); // Refresh offers list after deletion
        setConfirmDeleteOpen(false);
      }
    } catch (error) {
      console.log("Error deleting the offer", error);
    }
  };

  const handleDeleteClick = (offer) => {
    setOfferToDelete(offer);
    setConfirmDeleteOpen(true);
  };

  const handleCancelDelete = () => {
    setOfferToDelete(null);
    setConfirmDeleteOpen(false);
  };

  const handleChange = (field, value) => {
    setCurrentOffer({ ...currentOffer, [field]: value });
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom>
        Special Offers
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleOpenDialog()}
        style={{ marginBottom: "20px" }}
      >
        Add Offer
      </Button>
      {offers.length >= 1 ? (
        <Grid container spacing={3}>
          {offers.map((offer) => (
            <Grid item xs={12} sm={6} md={4} key={offer._id}>
             <Card onClick={() => handleOpenDialog(offer)} style={{ cursor: "pointer" }}>
                {offer.mediaType === "IMAGE" ? (
                  <CardMedia
                    component="img"
                    alt={offer.title}
                    image={offer.url}
                    title={offer.title}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                ) : offer.mediaType === "VIDEO" ? (
                  <div style={{ height: "200px", overflow: "hidden" }}>
                    <video width="100%" height="200px" controls>
                      <source src={offer.url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : null}
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {offer.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" paragraph>
                    {offer.description}
                  </Typography>
                </CardContent>
                <IconButton
                  aria-label="delete"
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                  }}
                  onClick={() => handleDeleteClick(offer)}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="body1" color="textSecondary" style={{ marginTop: "20px" }}>
          No offers available at the moment. Please check back later.
        </Typography>
      )}

      {/* Offer Dialog */}
      <OfferDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onSave={handleSaveOffer}
        offer={currentOffer}
        onChange={handleChange}
        isEditMode={isEditMode}
      />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={confirmDeleteOpen}
        onClose={handleCancelDelete}
        aria-labelledby="confirm-delete-title"
        aria-describedby="confirm-delete-description"
      >
        <DialogTitle id="confirm-delete-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-delete-description">
            Are you sure you want to delete this offer? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteOffer} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Offers;
